import { z } from 'zod/v3';

export const knowledgeBuilderValueSchema = z.object({
  draftId: z.string().optional(),
  version: z.number().optional(),
  validationStatus: z.enum(['unknown', 'valid', 'invalid']).optional(),
  reviewConfirmed: z.literal(true),
  review: z
    .object({
      status: z.string(),
      files: z.string(),
      validation: z.string(),
      pendingAiChanges: z.number(),
      unsavedDocuments: z.number(),
      completenessIssues: z.number(),
    })
    .optional(),
  sessionId: z.string().optional(),
  context: z
    .object({
      kind: z.string().optional(),
      entityRef: z.string().optional(),
      tenantRef: z.string().optional(),
      domainRef: z.string().optional(),
      systemRef: z.string().optional(),
      componentRef: z.string().optional(),
    })
    .optional(),
  documents: z
    .array(
      z.object({
        path: z.string(),
        documentId: z.string(),
        revision: z.number(),
        status: z.enum(['draft', 'accepted']),
      }),
    )
    .optional(),
  sources: z
    .array(
      z.object({
        sourceId: z.string(),
        type: z.enum(['file', 'url', 'catalog', 'repository']),
      }),
    )
    .optional(),
});

export const knowledgeBuilderUiOptionsSchema = z.object({
  documentSet: z
    .enum(['tenant', 'domain', 'system', 'component', 'template', 'custom'])
    .optional(),
  templateRef: z.string().optional(),
  sourcePath: z.string().optional(),
  initialDocument: z.string().optional(),
  definitionSchemaPath: z.string().optional(),
  definitionInterviewInstructionsPath: z.string().optional(),
  valuesTemplatePath: z.string().optional(),
  agent: z
    .object({
      id: z.string().optional(),
      provider: z.string().optional(),
      instructionsPath: z.string().optional(),
      tools: z
        .object({
          enabled: z.boolean().optional(),
        })
        .optional(),
    })
    .optional(),
  allowFiles: z.boolean().optional(),
  allowLinks: z.boolean().optional(),
  allowCatalogContext: z.boolean().optional(),
  maxFiles: z.number().optional(),
  maxFileSizeMb: z.number().optional(),
  height: z.number().optional(),
  contextFields: z
    .object({
      kind: z.string().optional(),
      tenantRef: z.string().optional(),
      domainRef: z.string().optional(),
      systemRef: z.string().optional(),
      componentRef: z.string().optional(),
      entityRef: z.string().optional(),
      templateParameters: z.array(z.string()).optional(),
    })
    .optional(),
});
